module.exports = __webpack_public_path__ + "img/img-39.505e5b05.png";